<template>
  <v-card class="ModalCreateProject modal_window">
    <h4 class="ModalCreateProject__title">Create new project</h4>
    <v-card-subtitle>
      A Project is a great way to organise your sites and plugins
    </v-card-subtitle>
    <v-card-text class="mt-2">
      <span class="ModalCreateProject__label">Enter project name</span>
      <v-text-field
        v-model.trim="name"
        class="pa-0 ModalCreateProject__input"
        autofocus
        hide-details
        filled
        dense
      />
      <div v-if="errorMain" class="error-main mt-4 pa-4">
        {{ errorMain }}
      </div>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions class="pa-6 ModalCreateProject__footer">
      <v-btn @click="close" color="n5">Cancel</v-btn>
      <v-btn
        @click="onCreate"
        color="y1"
        :disabled="!name || name.length === 0"
      >
        Create project
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ModalCreateProject',
  data() {
    return {
      name: '',
      errorMain: '',
    }
  },
  methods: {
    onCreate() {
      if (!this.name) {
        return
      }

      const projectData = {
        project: {
          name: this.name,
          ...(this.$store.state.organisations.current.id === 0
            ? { user_id: this.$store.state.user.current.id }
            : { organisation_id: this.$store.state.organisations.current.id }),
        },
      }

      this.$store
        .dispatch('projects/create', projectData)
        .then(() => {
          this.$emit('close')
        })
        .catch((e) => {
          console.error('Project creation failed:', e)
          if (e?.body?.errors) {
            // Handle array of errors or object with error messages
            if (Array.isArray(e.body.errors)) {
              this.errorMain = e.body.errors.join('. ')
            } else if (e.body.errors.name) {
              // Handle name-specific validation errors
              const nameErrors = Array.isArray(e.body.errors.name)
                ? e.body.errors.name
                : [e.body.errors.name]
              this.errorMain = nameErrors.join('. ')
            } else {
              // Handle object with multiple error fields
              this.errorMain = Object.values(e.body.errors)
                .flat()
                .join('. ')
            }
          } else if (e?.body?.error) {
            // Handle single error message
            this.errorMain = e.body.error
          } else if (e?.message) {
            this.errorMain = e.message
          } else {
            this.errorMain = 'Failed to create project. Please try again.'
          }
        })
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.error-main {
  background: #e94a53;
  border-radius: 2px;
}

$style: ModalCreateProject;
.#{$style} {
  &.theme--dark.v-card {
    @extend %modal-body-styles;
    min-width: 600px;
    padding: 24px 24px 0;
  }
  &__title {
    font-weight: 500;
    font-size: $H16;
    color: $white;
    margin-bottom: 32px;
  }
  &__label {
    @extend %label-styles;
  }
  &__input {
    &.v-text-field--filled.v-input--dense > .v-input__control > .v-input__slot {
      @extend %input-styles;
    }
    &.v-input input {
      color: $white;
    }
  }
  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px 0;
    gap: 16px;
    & > .theme--dark.v-btn {
      color: $white;
    }
  }
}
</style>
